"use strict";
import AuditFlagEditor from "./audit_flag_editor";
import "classnames";
import reactUtils from "../../react_utils";
import Api from "../../api/api";
import DocumentBrowser from "../react_document_browser";
import {
  GroupedDocumentBrowserModel,
  UngroupedGroupCopyCreator
} from "../grouped_document_browser_model";
import WaitingSpinner from "../../components/waiting_spinner";
const bem = reactUtils.makeBem("factor-invoice");
export default React.createClass({
  getInitialState() {
    return {
      auditFlags: this.props.auditFlags,
      saving: false
    };
  },
  render() {
    return /* @__PURE__ */ React.createElement(WaitingSpinner, { when: this.state.saving }, /* @__PURE__ */ React.createElement("div", { className: bem("__audit-review") }, /* @__PURE__ */ React.createElement(
      AuditFlagEditor,
      {
        flags: this.state.auditFlags,
        compact: true,
        transportationClient: this.transportationClient(),
        overriddenFlags: this.overriddenFlags(),
        onFlagUpdate: this.updateAuditFlags
      }
    ), /* @__PURE__ */ React.createElement("div", { className: bem("__audit-review-actions") }, /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "button--progress",
        onClick: this.finish
      },
      "Save Flags and Continue"
    ), "\xA0", /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "button--cancel",
        onClick: this.cancel
      },
      "Cancel"
    )), /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "column small-5" }, /* @__PURE__ */ React.createElement(
      DocumentBrowser,
      {
        model: this.documentBrowserModel(),
        allowsEditing: false,
        allowsEditingPodStatus: false,
        location: this.props.location,
        toggleDocumentData: this.toggleDocumentData,
        collapseSingleGroup: true
      }
    )), /* @__PURE__ */ React.createElement("div", { className: "column small-5" }, /* @__PURE__ */ React.createElement(
      DocumentBrowser,
      {
        model: this.documentBrowserModel(),
        allowsEditing: false,
        allowsEditingPodStatus: false,
        location: this.props.location,
        toggleDocumentData: this.toggleDocumentData,
        collapseSingleGroup: true
      }
    )))));
  },
  documentBrowserModel() {
    return new GroupedDocumentBrowserModel(
      new UngroupedGroupCopyCreator(this.props.model),
      () => false,
      void 0
    );
  },
  transportationClient() {
    return this.state.factorInvoice && this.state.factorInvoice.carrier && this.state.factorInvoice.carrier.transportation_client;
  },
  overriddenFlags() {
    return Api.Account.overriddenAuditFlags();
  },
  updateAuditFlags(flags) {
    this.setState({ auditFlags: flags });
  },
  cancel(event) {
    event.preventDefault();
    event.stopPropagation();
    this.props.onCancel();
  },
  finish(event) {
    this.setState({ saving: true }, () => {
      return Api.FactorInvoices.create({
        audit_flags: this.state.auditFlags,
        factor_invoice: this.props.factorInvoice,
        documents: this.props.documentIds
      }).then(this.props.onContinue);
    });
  }
});
